module.exports = __webpack_public_path__ + "img/iot2.12d05085.png";